<template>
  <div class="icon-content">
    <div class="center-tip">
      <span>请使用支付宝扫码</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {},
};
</script>

<style lang="less" scoped>
.icon-content {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding-top: 126px;
  justify-content: flex-start;
  align-items: center;

  .icon-tip {
    width: 136px;
    height: 136px;
  }

  .center-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    // color: #666;
    font-size: 36px;
    margin-top: 55px;
    .center-item {
      padding-top: 16px;
    }
  }

  .buy-button {
    background-color: var(--primary-color);
    color: #fff;
    font-size: 32px;
    margin-top: 150px;
    width: calc(100vw - 80px);
    height: 90px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    // touch-action: manipulation;
    user-select: none;
    transition: opacity 0.2s ease;
    &:active {
      opacity: 0.9;
    }
  }
}
</style>
